import { Controller } from '@hotwired/stimulus';
import { transitionSteps } from '../lib/step_transition';

export default class extends Controller {
  static targets = ['displayStep', 'formStep'];

  disconnect() {
    if (this.pendingTimeout) {
      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = null;
    }
  }

  showForm() {
    this.#transition(this.displayStepTarget, this.formStepTarget, 'forward');
  }

  showDisplay() {
    this.#transition(this.formStepTarget, this.displayStepTarget, 'backward');
  }

  #transition(outEl, inEl, direction) {
    if (this.pendingTimeout) clearTimeout(this.pendingTimeout);
    this.pendingTimeout = transitionSteps(outEl, inEl, direction);
  }
}
